import { assertConversionRuleIsValid, } from './KojiConverter';
import inlineConversionRules from './inline_rules';
import blockConversionRules from './block_rules';
import Mustache from 'mustache';
export class KojiLaTeXConverter {
    constructor(options) {
        this.inlineConversionRuleMap = {};
        this.blockConversionRuleMap = {};
        inlineConversionRules.forEach((rule) => {
            this.inlineConversionRuleMap[rule.elemName] = rule;
        });
        blockConversionRules.forEach((rule) => {
            this.blockConversionRuleMap[rule.elemName] = rule;
        });
        if (options && options.rules) {
            options.rules.forEach((rule) => {
                assertConversionRuleIsValid(rule);
                if (rule.type === 'inline') {
                    this.inlineConversionRuleMap[rule.elemName] =
                        rule;
                }
                else if (rule.type === 'block') {
                    this.blockConversionRuleMap[rule.elemName] = rule;
                }
            });
        }
    }
    convert(ast) {
        const children = this.convertChildren([ast.body]);
        return this.document(`${children.join('')}`);
    }
    convertChildren(children) {
        return children.map((content) => {
            return content
                .map((node) => {
                if (typeof node === 'string') {
                    if (node === '\n')
                        return '\\\\\n';
                    return `${node}`;
                }
                else if (this.isBlockNode(node)) {
                    return this.convertBlock(node);
                }
                else if (this.isInlineNode(node)) {
                    return this.convertInline(node);
                }
            })
                .join('');
        });
    }
    convertInline(node) {
        if (this.inlineConversionRuleMap[node.name]) {
            const rule = this.inlineConversionRuleMap[node.name];
            return Mustache.render(rule.latexTemplate, this.buildMustacheVariables(node));
        }
        else {
            const children = this.convertChildren(node.children).join('');
            return `${children}`;
        }
    }
    convertBlock(node) {
        const children = this.convertChildren(node.children).join('');
        return `${children}`;
    }
    buildMustacheVariables(node) {
        const children = this.convertChildren(node.children);
        const vars = {};
        vars['$0'] = children;
        for (let i = 0; i < 10; i++) {
            if (children[i]) {
                vars[`$${i + 1}`] = children[i];
            }
        }
        return vars;
    }
    isBlockNode(block) {
        return block.type === 'block';
    }
    isInlineNode(block) {
        return block.type === 'inline';
    }
    document(content) {
        return `% みんなで翻刻テキストLaTeXエクスポート（試験版）
% 金水敏先生が公開するkunten2e.sty(http://www.let.osaka-u.ac.jp/~kinsui/tex/kunten2e.sty)を使用してコンパイルしてください

\\documentclass[dvipdfmx,autodetect-engine]{utbook}% 
\\usepackage{kuten2e,color}
\\usepackage[normalem]{ulem}
\\begin{document}
${content}
\\end{document}
`;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiS29qaUxhVGVYQ29udmVydGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NvbnZlcnRlci9Lb2ppTGFUZVhDb252ZXJ0ZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTUEsT0FBTyxFQUlMLDJCQUEyQixHQUM1QixNQUFNLGlCQUFpQixDQUFDO0FBQ3pCLE9BQU8scUJBQXFCLE1BQU0sZ0JBQWdCLENBQUM7QUFDbkQsT0FBTyxvQkFBb0IsTUFBTSxlQUFlLENBQUM7QUFDakQsT0FBTyxRQUFRLE1BQU0sVUFBVSxDQUFDO0FBRWhDLE1BQU0sT0FBTyxrQkFBa0I7SUFRN0IsWUFBWSxPQUEyQjtRQVB2Qyw0QkFBdUIsR0FFbkIsRUFBRSxDQUFDO1FBQ1AsMkJBQXNCLEdBRWxCLEVBQUUsQ0FBQztRQUdMLHFCQUFxQixDQUFDLE9BQU8sQ0FBQyxDQUFDLElBQUksRUFBRSxFQUFFO1lBQ3JDLElBQUksQ0FBQyx1QkFBdUIsQ0FBQyxJQUFJLENBQUMsUUFBUSxDQUFDLEdBQUcsSUFBSSxDQUFDO1FBQ3JELENBQUMsQ0FBQyxDQUFDO1FBQ0gsb0JBQW9CLENBQUMsT0FBTyxDQUFDLENBQUMsSUFBSSxFQUFFLEVBQUU7WUFDcEMsSUFBSSxDQUFDLHNCQUFzQixDQUFDLElBQUksQ0FBQyxRQUFRLENBQUMsR0FBRyxJQUFJLENBQUM7UUFDcEQsQ0FBQyxDQUFDLENBQUM7UUFDSCxJQUFJLE9BQU8sSUFBSSxPQUFPLENBQUMsS0FBSyxFQUFFO1lBQzVCLE9BQU8sQ0FBQyxLQUFLLENBQUMsT0FBTyxDQUFDLENBQUMsSUFBSSxFQUFFLEVBQUU7Z0JBQzdCLDJCQUEyQixDQUFDLElBQUksQ0FBQyxDQUFDO2dCQUNsQyxJQUFJLElBQUksQ0FBQyxJQUFJLEtBQUssUUFBUSxFQUFFO29CQUMxQixJQUFJLENBQUMsdUJBQXVCLENBQUMsSUFBSSxDQUFDLFFBQVEsQ0FBQzt3QkFDekMsSUFBSSxDQUFDO2lCQUNSO3FCQUFNLElBQUksSUFBSSxDQUFDLElBQUksS0FBSyxPQUFPLEVBQUU7b0JBQ2hDLElBQUksQ0FBQyxzQkFBc0IsQ0FBQyxJQUFJLENBQUMsUUFBUSxDQUFDLEdBQUcsSUFBSSxDQUFDO2lCQUNuRDtZQUNILENBQUMsQ0FBQyxDQUFDO1NBQ0o7SUFDSCxDQUFDO0lBRUQsT0FBTyxDQUFDLEdBQXFCO1FBQzNCLE1BQU0sUUFBUSxHQUFHLElBQUksQ0FBQyxlQUFlLENBQUMsQ0FBQyxHQUFHLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQztRQUNsRCxPQUFPLElBQUksQ0FBQyxRQUFRLENBQUMsR0FBRyxRQUFRLENBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBQyxFQUFFLENBQUMsQ0FBQztJQUMvQyxDQUFDO0lBRUQsZUFBZSxDQUNiLFFBQTRDO1FBRTVDLE9BQU8sUUFBUSxDQUFDLEdBQUcsQ0FBQyxDQUFDLE9BQU8sRUFBRSxFQUFFO1lBQzlCLE9BQU8sT0FBTztpQkFDWCxHQUFHLENBQUMsQ0FBQyxJQUFJLEVBQUUsRUFBRTtnQkFDWixJQUFJLE9BQU8sSUFBSSxLQUFLLFFBQVEsRUFBRTtvQkFDNUIsSUFBSSxJQUFJLEtBQUssSUFBSTt3QkFBRSxPQUFPLFFBQVEsQ0FBQztvQkFDbkMsT0FBTyxHQUFHLElBQUksRUFBRSxDQUFDO2lCQUNsQjtxQkFBTSxJQUFJLElBQUksQ0FBQyxXQUFXLENBQUMsSUFBSSxDQUFDLEVBQUU7b0JBQ2pDLE9BQU8sSUFBSSxDQUFDLFlBQVksQ0FBQyxJQUFJLENBQUMsQ0FBQztpQkFDaEM7cUJBQU0sSUFBSSxJQUFJLENBQUMsWUFBWSxDQUFDLElBQUksQ0FBQyxFQUFFO29CQUNsQyxPQUFPLElBQUksQ0FBQyxhQUFhLENBQUMsSUFBSSxDQUFDLENBQUM7aUJBQ2pDO1lBQ0gsQ0FBQyxDQUFDO2lCQUNELElBQUksQ0FBQyxFQUFFLENBQUMsQ0FBQztRQUNkLENBQUMsQ0FBQyxDQUFDO0lBQ0wsQ0FBQztJQUVELGFBQWEsQ0FBQyxJQUFpQjtRQUM3QixJQUFJLElBQUksQ0FBQyx1QkFBdUIsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLEVBQUU7WUFDM0MsTUFBTSxJQUFJLEdBQ1IsSUFBSSxDQUFDLHVCQUF1QixDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsQ0FBQztZQUMxQyxPQUFPLFFBQVEsQ0FBQyxNQUFNLENBQ3BCLElBQUksQ0FBQyxhQUFhLEVBQ2xCLElBQUksQ0FBQyxzQkFBc0IsQ0FBQyxJQUFJLENBQUMsQ0FDbEMsQ0FBQztTQUNIO2FBQU07WUFDTCxNQUFNLFFBQVEsR0FBRyxJQUFJLENBQUMsZUFBZSxDQUNuQyxJQUFJLENBQUMsUUFBUSxDQUNkLENBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBQyxDQUFDO1lBQ1gsT0FBTyxHQUFHLFFBQVEsRUFBRSxDQUFDO1NBQ3RCO0lBQ0gsQ0FBQztJQUVELFlBQVksQ0FBQyxJQUFtQjtRQUM5QixNQUFNLFFBQVEsR0FBRyxJQUFJLENBQUMsZUFBZSxDQUNuQyxJQUFJLENBQUMsUUFBUSxDQUNkLENBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBQyxDQUFDO1FBQ1gsT0FBTyxHQUFHLFFBQVEsRUFBRSxDQUFDO0lBQ3ZCLENBQUM7SUFFTyxzQkFBc0IsQ0FBQyxJQUFpQjtRQUM5QyxNQUFNLFFBQVEsR0FBRyxJQUFJLENBQUMsZUFBZSxDQUFDLElBQUksQ0FBQyxRQUFRLENBQUMsQ0FBQztRQUNyRCxNQUFNLElBQUksR0FBRyxFQUFFLENBQUM7UUFDaEIsSUFBSSxDQUFDLElBQUksQ0FBQyxHQUFHLFFBQVEsQ0FBQztRQUN0QixLQUFLLElBQUksQ0FBQyxHQUFHLENBQUMsRUFBRSxDQUFDLEdBQUcsRUFBRSxFQUFFLENBQUMsRUFBRSxFQUFFO1lBQzNCLElBQUksUUFBUSxDQUFDLENBQUMsQ0FBQyxFQUFFO2dCQUNmLElBQUksQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFDLEVBQUUsQ0FBQyxHQUFHLFFBQVEsQ0FBQyxDQUFDLENBQUMsQ0FBQzthQUNqQztTQUNGO1FBQ0QsT0FBTyxJQUFJLENBQUM7SUFDZCxDQUFDO0lBRU8sV0FBVyxDQUFDLEtBQVU7UUFDNUIsT0FBTyxLQUFLLENBQUMsSUFBSSxLQUFLLE9BQU8sQ0FBQztJQUNoQyxDQUFDO0lBRU8sWUFBWSxDQUNsQixLQUFVO1FBRVYsT0FBTyxLQUFLLENBQUMsSUFBSSxLQUFLLFFBQVEsQ0FBQztJQUNqQyxDQUFDO0lBRU8sUUFBUSxDQUFDLE9BQWU7UUFDOUIsT0FBTzs7Ozs7OztFQU9ULE9BQU87O0NBRVIsQ0FBQztJQUNBLENBQUM7Q0FDRiJ9